import { useEffect, useState } from "react";
import { mostrarNotif } from "../hooks/useNotificacoes";
import { obterStatusPush, observarStatusPush } from "../utils/notificacoesAndroid";

export default function NotificacoesCelular() {
  const [status, setStatus] = useState(obterStatusPush);
  const [testando, setTestando] = useState(false);
  const [resultado, setResultado] = useState("");
  useEffect(() => observarStatusPush(setStatus), []);
  if (window.Capacitor?.getPlatform?.() !== "android") return null;
  const textos = {
    registrado: "Celular registrado para receber mensagens e pedidos.",
    bloqueado: "Notificações bloqueadas. Ative em Configurações do Android → Apps → Print Control → Notificações.",
    erro: "Não foi possível registrar este celular. Confira a internet e tente novamente.",
    registrando: "Registrando este celular para receber notificações…",
    aguardando: "Aguardando o registro deste celular.",
  };
  const testar = async () => {
    setTestando(true);
    setResultado("");
    window.dispatchEvent(new Event("pc-push-retry"));
    try {
      const ok = await mostrarNotif("Notificações do Print Control", "Este é um teste da central de notificações do celular.");
      setResultado(ok
        ? "Teste enviado à central do Android. Isso testa a exibição local; não simula uma mensagem de cliente."
        : "O Android não permitiu exibir o teste. Confira a permissão e o canal Avisos do Print Control.");
    } finally { setTestando(false); }
  };
  return <div style={{ marginBottom: 18, padding: 14, border: "1px solid #365269", borderRadius: 12, background: "#102333" }}>
    <strong style={{ color: "#d6e8f3", fontSize: 13 }}>Notificações do celular</strong>
    <p style={{ color: "#a8c0d1", fontSize: 12, lineHeight: 1.6 }}>{textos[status.estado] || textos.aguardando}</p>
    <p style={{ color: "#a8c0d1", fontSize: 12, lineHeight: 1.6 }}>Mensagens, pedidos e avisos de versão aparecem na central do Android, sem abrir avisos dentro do aplicativo.</p>
    <button type="button" disabled={testando} onClick={testar} style={{ minHeight: 44, padding: "8px 12px", background: "#154c42", color: "#a7f2df", border: "1px solid #367b68", borderRadius: 8, cursor: "pointer" }}>
      {testando ? "Testando…" : "Testar notificação e reconectar"}
    </button>
    {resultado && <p role="status" style={{ color: "#c4d8e7", fontSize: 12, lineHeight: 1.6 }}>{resultado}</p>}
  </div>;
}
